function waitForSwiperAndElements(callback) {
  const ready =
    typeof Swiper !== "undefined" &&
    document.querySelector(".product-carousel .swiper-wrapper");

  if (ready) {
    callback();
  } else {
    setTimeout(() => waitForSwiperAndElements(callback), 50);
  }
}

function initProductCarousels() {
  const carousels = document.querySelectorAll('.product-carousel');
  if (!carousels.length) return;

  carousels.forEach(carousel => {
    const wrapper = carousel.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    if (wrapper.classList.contains("swiper-initialized")) return;

    new Swiper(carousel, {
      slidesPerView: 1.5,
      spaceBetween: 16,
      loop: false,
      pagination: {
        el: carousel.querySelector('.product-pagination'),
        clickable: true,
      },
      breakpoints: {
        750: { slidesPerView: 2.5, spaceBetween: 20 },
        990: { slidesPerView: 3.5, spaceBetween: 24 },
        1200: { slidesPerView: 4, spaceBetween: 24 },
      },
    });
  });
}

function initFAQAccordions() {
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const parent = btn.closest('.faq-item');
      parent.classList.toggle('active');
    });
  });
}

function runWhenReady() {
  waitForSwiperAndElements(initProductCarousels);
  initFAQAccordions();
}

document.addEventListener('DOMContentLoaded', runWhenReady);
document.addEventListener('shopify:section:load', runWhenReady);
document.addEventListener('shopify:section:reorder', runWhenReady);
document.addEventListener('product-recommendations:updated', runWhenReady);
